import {
  faClockRotateLeft as faClockRotateLeftRegular,
  faHouseWindow as faHouseWindowRegular,
  faLayerGroup as faLayerGroupRegular,
  faPalette as faPaletteRegular,
} from "@fortawesome/sharp-regular-svg-icons";
import {
  faClockRotateLeft,
  faHouseWindow,
  faLayerGroup,
  faPalette,
} from "@fortawesome/sharp-solid-svg-icons";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

import { Icon } from "@/components/ui-v2";
import { NodesIcon } from "@/components/ui-v2/icons";
import useBasicData from "@/hooks/useBasicData";

import { PrimaryNavigationLink } from "./components/PrimaryNavigationLink/PrimaryNavigationLink";

const Container = styled("nav")({
  display: "flex",
  flexDirection: "column",
});

export const PrimaryNavigationLinks = () => {
  const { pathname } = useLocation();
  const { activeWorkspace } = useBasicData();

  if (!activeWorkspace) {
    return null;
  }

  return (
    <Container>
      <PrimaryNavigationLink
        label="Home"
        to={`/${activeWorkspace.name}`}
        active={pathname === `/${activeWorkspace.name}`}
        icon={<Icon size="medium" icon={faHouseWindowRegular} />}
        activeIcon={<Icon size="medium" icon={faHouseWindow} />}
      />
      {activeWorkspace.myPermissions.includes("asset:view") && (
        <PrimaryNavigationLink
          label="Drive"
          to={`/${activeWorkspace.name}/drive`}
          active={pathname.startsWith(`/${activeWorkspace.name}/drive`)}
          icon={<Icon size="medium" icon={faLayerGroupRegular} />}
          activeIcon={<Icon size="medium" icon={faLayerGroup} />}
        />
      )}
      {activeWorkspace.myPermissions.includes("style:view") ? (
        <PrimaryNavigationLink
          label="Models"
          to={`/${activeWorkspace.name}/models`}
          active={
            pathname.startsWith(`/${activeWorkspace.name}/styles`) ||
            pathname.startsWith(`/${activeWorkspace.name}/models`)
          }
          icon={<Icon size="medium" icon={faPaletteRegular} />}
          activeIcon={<Icon size="medium" icon={faPalette} />}
        />
      ) : null}
      {activeWorkspace.myPermissions.includes("blueprint:view") && (
        <PrimaryNavigationLink
          label="Workflows"
          to={`/${activeWorkspace.name}/workflows`}
          active={pathname.startsWith(`/${activeWorkspace.name}/workflows`)}
          icon={<NodesIcon />}
          activeIcon={<NodesIcon sx={{ color: "white" }} />}
        />
      )}
      <PrimaryNavigationLink
        label="Activity"
        to={`/${activeWorkspace.name}/activity`}
        active={pathname.startsWith(`/${activeWorkspace.name}/activity`)}
        icon={<Icon size="medium" icon={faClockRotateLeftRegular} />}
        activeIcon={<Icon size="medium" icon={faClockRotateLeft} />}
      />
    </Container>
  );
};
